import { render, staticRenderFns } from "./goodspost.vue?vue&type=template&id=6b84c7a0&scoped=true"
import script from "./goodspost.vue?vue&type=script&lang=js"
export * from "./goodspost.vue?vue&type=script&lang=js"
import style0 from "./goodspost.vue?vue&type=style&index=0&id=6b84c7a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84c7a0",
  null
  
)

export default component.exports